module.exports = __webpack_public_path__ + "e34a9ca5dcd5e4c4eeb81d82816545c9.svg";